var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSquare = function SvgSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.273 2.049a2.68 2.68 0 0 1 2.677 2.678v14.546a2.68 2.68 0 0 1-2.677 2.677H4.727a2.68 2.68 0 0 1-2.678-2.677V4.727a2.68 2.68 0 0 1 2.678-2.678zm-14.546 1.2a1.48 1.48 0 0 0-1.479 1.478v14.546a1.48 1.48 0 0 0 1.479 1.478h14.546a1.48 1.48 0 0 0 1.478-1.479V4.728c0-.817-.662-1.479-1.478-1.479z"
  })));
};
export default SvgSquare;